import { Box, Typography } from "@mui/material";

// Label above a value. `mono` renders the value in a monospace face and lets long,
// unbreakable strings (ids, algorithm versions) wrap instead of overflowing.
export default function Detail({ label, children, mono }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          fontFamily: mono ? "monospace" : undefined,
          wordBreak: mono ? "break-all" : undefined,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}
